<template>
  <v-navigation-drawer
    id="appDrawer"
    :mini-variant.sync="mini"
    :dark="$vuetify.dark"
    v-model="drawer"
    width="250"
    app
    :temporary="$vuetify.breakpoint.mobile"
  >
    <v-toolbar class="app-logo">
      <router-link to="/" title="ARCE - Agência de Regulação do Estado do Ceará">
        <img
          src="@/assets/images/logo.png"
          width="180"
          class="mat-toolbar__img"
          alt="ARCE Logo"
        />
      </router-link>
    </v-toolbar>

    <div class="drawer-menu--scroll">
      <app-side-bar />
    </div>

    <template v-slot:append>
      <div class="pa-2 text-center app-version">
        <span class="body-2">
          &copy; 2020-{{ currentYear.getFullYear() }} {{ version }}
        </span>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import GlobalStore from "@/store/modules/global";
import AppSideBar from "@/components/AppSideBar";
import { VERSION_APP } from "@/commons/config";

export default {
  components: { AppSideBar },
  data: () => ({
    mini: false,
    version: `v${VERSION_APP}`,
    currentYear: new Date()
  }),
  computed: {
    drawer: {
      get: () => GlobalStore.drawer,
      set: v => GlobalStore.setDrawer(v)
    }
  }
};
</script>

<style lang="scss">
.app-logo {
  border-bottom: 1px solid #e0e0e0 !important;
  box-shadow: none !important;
  a {
    display: table;
    margin: auto;
  }
}

.app-version {
  border-top: 1px solid #e0e0e0 !important;
}

#appDrawer {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100dvh !important; 
}

.drawer-menu--scroll {
  flex: 1 1 auto;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  height: auto !important;
  min-height: 0; /* evita colapso */
}

@supports not (height: 100dvh) {
  #appDrawer {
    height: calc(100vh - 0px) !important;
  }
}

.mat-toolbar__img {
  margin: auto;
  display: table;
}
</style>
